module.exports = __webpack_public_path__ + "img/status.1cb86248.svg";